import { Dropdown } from "@carbon/react";
import { FC } from "react";

import { SupportedLocale } from "src/internationalization/locale/supported.locale.enum.ts";
import { useLocale } from "src/internationalization/locale/useLocale.ts";

type LocaleInfo = {
  locale: SupportedLocale;
  name: string;
};

const AVAILABLE_LOCALES: LocaleInfo[] = [
  {
    locale: SupportedLocale.FrFR,
    name: "Français",
  },
  {
    locale: SupportedLocale.EnGB,
    name: "English",
  },
];

export const LocaleSwitcher: FC = () => {
  const { locale, changeLocale } = useLocale();
  const selectedItem = AVAILABLE_LOCALES.find(
    (availableLocale) => availableLocale.locale === locale
  );

  return (
    <Dropdown
      titleText={selectedItem?.name ?? ""}
      type="inline"
      items={AVAILABLE_LOCALES}
      itemToString={(item) => item?.name ?? ""}
      onChange={({ selectedItem }) => selectedItem && changeLocale(selectedItem.locale)}
      selectedItem={selectedItem}
      id="language-switcher"
      label={selectedItem?.name ?? ""}
    />
  );
};
